export var CommonSchemaIds;
(function (CommonSchemaIds) {
    CommonSchemaIds["VISIBLE"] = "visible";
    CommonSchemaIds["BASE_INTERVAL"] = "base-interval";
    CommonSchemaIds["INTERVAL"] = "interval";
})(CommonSchemaIds || (CommonSchemaIds = {}));
